import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { ParentValueComponentContext } from "@plansoft-configuration-renderer/layout";
import { AttributeValueContentType } from "../../AttributeValue/AttributeValueContentType";
import { ThumbnailAction } from "./ThumbnailAction";
export function ThumbnailInfo(props) {
    // reuse existing component and wrap it in ThumbnailAction
    const components = useContext(ParentValueComponentContext);
    const Component = components[AttributeValueContentType.Help];
    return (_jsx(ThumbnailAction, { children: _jsx(Component, Object.assign({}, props)) }));
}
//# sourceMappingURL=ThumbnailInfo.js.map